import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tavaklient

  <span style="color:#85c1dc;">**FI:**</span>
  Tavallinen asiakas

  <span style="color:#85c1dc;">**RU:**</span>
  Обычный клиент
*/
/* @__NO_SIDE_EFFECTS__ */
const m739 = msg(
  mf`Tavaklient`,
  mf`Tavallinen asiakas`,
  mf`Обычный клиент`,
)

export { m739 as 'w.cart.table.regular_price_col' }